export const environment = {
   production: false,
   baseUrl: 'https://jayd-webapi.veetech.uk/api',
   baseSocit: "https://jayd-cont.veetech.uk",
   //  baseSocit : "https://fouka-contapi.veetech.uk"
};
